import { render } from "./onboarding-sidebar.vue?vue&type=template&id=3d890e0c"
import script from "./onboarding-sidebar.vue?vue&type=script&lang=js"
export * from "./onboarding-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__